import template from './users-create.html';
import controller from './users-create.controller';
import './users-create.styl';

const usersCreateComponent = {
  template,
  controller,
  controllerAs: 'usersCreate',
  require: {
    app: '^^app'
  }
};

export default usersCreateComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-create/users-create.component.js
 **/